import React from 'react';
import {lazy} from '../templates/helpers';
import {withRenderStrategy} from '../utils/dynamic-rendering';

import {CACHE as LOADING_CACHE, placeholderFromType} from './common/loading';

export default function loadableModule({
    LoadableComponent,
    componentName,
    placeholder = null,
}) {
    const ModuleName = `${componentName}Module`;

    const BaseLoadableModule = ({ssr = true, ...rest}) => {
        const componentPlaceholder = placeholderFromType(LoadableModule); // eslint-disable-line no-use-before-define
        const element = (
            <LoadableComponent fallback={componentPlaceholder} {...rest} />
        );

        if (ssr) {
            return element;
        }

        return lazy(element);
    };

    const LoadableModule = withRenderStrategy(BaseLoadableModule);
    LoadableModule.displayName = ModuleName;

    if (placeholder) {
        LOADING_CACHE.set(LoadableModule, {
            ...placeholder,
            componentType: ModuleName,
        });
    }

    return LoadableModule;
}
